import { useEffect, useState } from "react";
import Header from "./Sections/Header";
import Slider from "./Sections/Slider";
import About from "./Sections/About";
import Services from "./Sections/Services";
import Staff from "./Sections/Staff";
import Footer from "./Sections/Footer";
import "./Style/theme1.scss"
import { useTranslation } from "react-i18next";

const ClientSiteTheme1 = (props) => {
  const { t, i18n } = useTranslation("clientSite");
  const { t: a } = useTranslation("auth");
  const [lang, setLang] = useState(props.lang)
const supported = (i18n.options?.supportedLngs || ['en', 'es']).filter(l => l !== 'cimode');
     useEffect(() => {
    document.title = props.site.siteTitle;
    	i18n.changeLanguage(props.lang)
  }, []);
  
   return (
    <div data-theme={props.site.themeId === 1 ? "one": props.site.themeId === 2 ? "two" : "one"}>
      <Header site={props.site}/>
      <Slider site={props.site} />
      {props.site.aboutUsPageEnabled ?
      <section id="about" className="section about-section about-left light-bg">
        <div className="" style={{marginRight:"auto"}}>
          <About site={props.site}/>
        </div>
      </section>
      :
      <>
      </>
      }
      {props.site.servicePageEnabled ?
      <section id="services" className="section services-section gray-bg">
        <div className="container">
          <Services site={props.site}/>
        </div>
      </section>
      :
      <>
      </>
      }
      {props.site.staffPageEnabled ?
      <section id="staff" className="section light-bg">
        <div className="container">
          <Staff site={props.site}/>
        </div>
      </section>
      :
      <>
      </>
      }
      <footer className="footer-site white">
        <div className="container">
          <Footer site={props.site}/>
        </div>
                          <div style={{display:"flex", justifyContent:"flex-end"}}>
            <label htmlFor="lang-switch" className="visually-hidden">
              {t('login.lang.ariaLabel')}
            </label>
                <div className="centered-select">
            </div>
            <select
              id="lang-switch"
              value={lang}
              onChange={(e) => {i18n.changeLanguage(e.target.value); setLang(e.target.value);}}
              aria-label={t('login.lang.ariaLabel')}
              className="lang-select"
              style={{
                
                padding: '6px 10px',
                borderRadius: 6,
                border: '1px solid #ddd',
                background: '#fff'
              }}
            >
              {supported.map(code => (
                <option key={code} value={code}>
                  {a(`login.lang.names.${code}`, code.toUpperCase())}
                </option>
              ))}
            </select>
          </div>
      </footer>
      
    </div>
   );
};

export default ClientSiteTheme1;
